export default ['Variable', 'ComponentMoleFlow', 'ComponentMassFlow', 'ComponentMassFrac', 'DistillationCurve', 'SpreadSheet'];
